// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DoneIcon from "@material-ui/icons/Done";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../styles/buttonStyles";
import type { IconStylesClassesType } from "../../styles/iconStyles";
import { buttonStyles } from "../../styles/buttonStyles";
import { iconStyles } from "../../styles/iconStyles";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  ...iconStyles(theme),
  fileUploadButton: {
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    padding: "22px 0",
    borderRadius: "3px",
    boxShadow: "0 0 0 1px " + theme.palette.primary.main,
    textAlign: "center",
    width: "100%",
    "&:hover, &.hover, &:active, &.active": {
      cursor: "pointer",
      backgroundColor: theme.palette.primary.third,
      color: theme.palette.primary.contrastText
    },
    "& > SPAN": {
      display: "block"
    }
  },
  fileUploadText: {
    fontSize: "1.5rem",
    lineHeight: "30px"
  },
  fileUploadInput: {
    opacity: 0,
    width: "0.1px",
    "&:hover, &.hover": {
      cursor: "pointer"
    }
  }
});

type DraggableUploadButtonClassesType = {
  ...ButtonStylesClassesType,
  ...IconStylesClassesType,
  fileUploadButton: DictionaryType,
  fileUploadText: DictionaryType,
  fileUploadInput: DictionaryType
};

type DraggableUploadButtonPropsType = {
  classes: DraggableUploadButtonClassesType,
  uploadFileActions: Function
};

type DraggableUploadButtonStatesType = {
  dragged: boolean
};

class DraggableUploadButton extends Component<
  DraggableUploadButtonPropsType,
  DraggableUploadButtonStatesType
> {
  constructor(props: DraggableUploadButtonPropsType) {
    super(props);
    this.state = {
      dragged: false
    };
  }

  preventDefault = (e: SyntheticInputEvent<*>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  inputDragLeave = (e: SyntheticInputEvent<*>) => {
    this.preventDefault(e);
    e.target.classList.toggle("hover");
    this.setState({ dragged: false });
  };

  inputDragEnter = (e: SyntheticInputEvent<*>) => {
    this.preventDefault(e);
    e.target.classList.toggle("hover");

    this.setState({ dragged: true });
  };

  inputDrop = (e: SyntheticInputEvent<*>, callback: Function) => {
    this.preventDefault(e);
    callback(e);
  };

  render(): React$Element<*> {
    const classes = this.props.classes;

    return (
      <div>
        <label
          htmlFor="raised-button-file"
          draggable={true}
          onDragEnter={this.inputDragEnter}
          onDragOver={this.preventDefault}
          onDrop={(e: SyntheticInputEvent<*>): Function =>
            this.inputDrop(e, this.props.uploadFileActions)
          }
          onDragLeave={this.inputDragLeave}
        >
          <Button
            variant="contained"
            component="span"
            color="primary"
            className={classNames(classes.primaryBtn, classes.fileUploadButton)}
          >
            <span className={classes.fileUploadText}>
              Drag and Drop
              <br />
              Photo here.
              <br />
              Or just Click it.
              <br />
            </span>
            {this.state.dragged ? (
              <DoneIcon className={classes.largeIcon} />
            ) : (
              <CloudUploadIcon className={classes.largeIcon} />
            )}
          </Button>
        </label>
        <input
          accept="image/*"
          onChange={this.props.uploadFileActions}
          id="raised-button-file"
          type="file"
          className={classes.fileUploadInput}
        />
      </div>
    );
  }
}

export default withStyles(styles)(DraggableUploadButton);
